import { carrerCardData, bgGradientStyle, bgwhiteStyle } from "./consts";

const CareerDetails = () => {
  return (
    <>
      {carrerCardData.map((card, idx) => {
        // Alternate background style per card
        const applyGradient = idx % 2 === 0;

        return (
          <div
            key={card.id}
            className="flex flex-col items-center p-6 w-full"
            style={applyGradient ? bgGradientStyle : bgwhiteStyle}
          >
            <div
              className="flex flex-col md:flex-row max-w-6xl bg-white rounded-xl p-4 border border-gray-300 overflow-hidden lg:mb-20 mb-10 lg:mt-10 h-auto min-h-[300px]" 
            >
              <div
                className={`w-full md:w-1/3 flex items-start justify-center bg-gradient-to-br from-white to-gray-50 p-6 ${
                  card.reverseLayout ? "order-1 md:order-2" : "order-1 md:order-1"
                }`}
              >
                <div className="relative">
                  <div
                    className={`absolute -top-3 ${
                      card.reverseLayout ? "-right-3" : "-left-3"
                    } w-full h-full border-4 border-[#d0e2e2] rounded-lg`}
                  ></div>
                  <img
                    src={card.imgSrc}
                    alt={card.imgAlt}
                    className="relative z-10 rounded-lg shadow-md"
                  />
                </div>
              </div>

              <div
                className={`w-full md:w-2/3 p-4 ${
                  card.reverseLayout ? "order-2 md:order-1" : "order-2 md:order-2"
                }`}
              >
                <p className="text-gray-700 text-lg text-justify leading-relaxed mb-4 lg:w-[700px]">
                  {card.description1}
                </p>

                {card.description2 && (
                  <p className="text-lg leading-relaxed mb-4 lg:w-[700px]">
                    {card.description2
                      .split(
                        /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/
                      )
                      .map((part, index) =>
                        part.includes("@") ? (
                          <a
                            key={index}
                            href={`mailto:${part}`}
                            className="text-red-600 underline"
                          >
                            {part}
                          </a>
                        ) : (
                          <span key={index} className="text-gray-700">
                            {part}
                          </span>
                        )
                      )}
                  </p>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default CareerDetails;
